import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DocumentTitle from '../components/DocumentTitle';
import Header from '../components/auth/Header';
import ProfileAccount from '../components/profile/Account';
import ProfileCertificate from '../components/profile/Certificate';
import { updateUserDataRequest } from '../actions/auth';
import __ from '../helpers/translation';

const propTypes = {
  auth: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  updateUserDataRequest: PropTypes.func.isRequired
};

class Profile extends Component {

    constructor (props) {
      super(props);
      this.state = {
        user: this.props.auth.user,
        activeTab: 'account'
      };
    }

    componentDidMount () {
      document.body.classList.add('bg-grey-image');
      this.props.updateUserDataRequest();
    }

    componentWillUnmount () {
      document.body.classList.remove(... document.body.classList);
    }

    certificate() {
        this.setState({
            activeTab: 'certificate'
        })
    }

    account() {
        this.setState({
            activeTab: 'account'
        })
    }

  render () {

    let header;
    let form;
    if(this.state.activeTab === 'account'){
        header = <Header title={__('app.navigation.profile')} />;
        form = <ProfileAccount {...this.props} />;
    } else {
        header = <Header title={__('app.navigation.profile')} />;
        form = <ProfileCertificate {...this.props} />;
    }
    

    return (
      <DocumentTitle title={`${__('app.navigation.profile')} - ${window.App.name}`}>
        <Fragment>
            
            {header}

            <div className="container mt-sm-3">
                <div className="flex-row tab-bar d-flex justify-content-space-between">
                    <div className={`link-top text-center ${this.state.activeTab === 'certificate' && "active"}`}
                        onClick={() => this.certificate()} >
                        <a className="cur-p">{ __('app.profile.tab_certificate') }</a>
                    </div>
                    <div className={`link-top text-center ${this.state.activeTab === 'account' && "active"}`} 
                        onClick={() => this.account()} >
                        <a className="cur-p">{ __('app.profile.tab_account') }</a>
                    </div>
                </div>
                <div className="row mt-4 mt-sm-5">
                    <div className="col-md-8 offset-md-2 col-12">
                        {form}
                    </div>
                </div>
            </div>
        </Fragment>
      </DocumentTitle>
    );
  }
}

Profile.propTypes = propTypes;

const mapStateToProps = ({ auth, loading }) => ({ auth, loading });

const mapDispatchToProps = {
  updateUserDataRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
